import React, {useEffect, useState, useContext} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';

import {labels} from '../../../util/utils';
import {createProjectStepsIndex} from '../../../util/uiconstants';
import {ProjectContext} from './Helper/context';

import {IconoirEditPencil} from '@ey-xd/motif-icon';

import CustomTable from '../../CoreWrappers/CustomTable';
import Button from '../../CoreWrappers/Button';
import Badge from '../../CoreWrappers/Badge';
import User from '../../CoreWrappers/User';

const ProjectOwner = (props) => {
	const isEditMode = useSelector((state) => state.isEditMode.activated);
	const isRollForwardMode = useSelector((state) => state.isRollForwardMode);
	const project = useSelector((store) => store.newProject);
	const {state, dispatch} = useContext(ProjectContext);
	const [users, setUsers] = useState([]);

	let userPreferences = useSelector((state) => state.userPreferences);

	useEffect(() => {
		var existingOwners = [];
		if (state.owners && state.owners.length > 0) {
			existingOwners = [...state.owners];
		} else {
			if (isEditMode || isRollForwardMode) {
				existingOwners = [...project.owners].sort(function(a, b) {
					return a.emailAddress.localeCompare(b.emailAddress);
				});
			} else {
				existingOwners.push({
					emailAddress: userPreferences.emailAddress,
					email: userPreferences.emailAddress,
					value: userPreferences.emailAddress,
					id: userPreferences.gui,
					isEmpty: false,
					isInternal: true,
					firstName: userPreferences.firstName,
					lastName: userPreferences.lastName,
					roles: [], // to do
					userId: userPreferences.gui
				});
			}
		}
		props.assaignProjectOwners(existingOwners);
		let userArray = [];
		let localUserCounter = 0;
		const usersContextArray = [];
		existingOwners.forEach((user) => {
			userArray.push({
				id: `user_${localUserCounter}`,
				isEmpty: false,
				isLoggedInUser: user.emailAddress == userPreferences.emailAddress
			});
			usersContextArray.push({
				id: `user_${localUserCounter}`,
				email: user.emailAddress,
				emailAddress: user.emailAddress,
				userId: user.userId,
				firstName: user.firstName,
				lastName: user.lastName,
				isInternal: true,
				isEmpty: false
			});
			localUserCounter = ++localUserCounter;
		});
		setUsers(usersContextArray);
	}, [project.users, isEditMode]);

	let teamConfig = [
		{
			label: labels.projectOwners,
			sortable: false,
			width: '90%',
			propName: 'name',
			customHeaderCell: (item) => {
				return (
					<>
						{labels.projectOwners}
						<Badge value={users.length} />
					</>
				);
			},
			customCell: (item) => {
				const person = {
					emailAddress: item.emailAddress,
					firstName: item.firstName,
					lastName: item.lastName,
					userInital: item.userInital
				};
				const personData = {person: person, viewType: 'twolines'};
				const userProps = {
					email: item.emailAddress,
					firstName: item.firstName,
					lastName: item.lastName,
					renderExtra: () => <>{item.emailAddress}</>
				};

				return <User {...userProps} />;
			}
		},
		{
			label: '',
			sortable: false,
			width: '10%',
			propName: 'icons',
			customHeaderCell: (item) => {
				const propsBtn = {
					svg: IconoirEditPencil,
					iconSize: 20,
					variant: 'text',
					title: labels.edit,
					onClick: () => props.handleEditIconClick(createProjectStepsIndex.selectClient)
				};

				return <Button {...propsBtn} />;
			}
		}
	];

	return (
		<CustomTable
			columns={teamConfig}
			data={users}
			showAccordions={false}
			paginationConfig={{
				disabled: true
			}}
			searchConfig={{
				disabled: true
			}}
			labelConfig={{
				yesLabel: labels.yes,
				noLabel: labels.no
			}}
		/>
	);
};

export default ProjectOwner;

const StyledViewCell = styled.section`
	display: flex;
	flex-direction: column;
	width: 90%;
`;

const StyledProjectOwnerTable = styled.section`
	.group-name {
		max-width: 82%;
		margin-right: 0.5rem;
	}
	.motif-icon {
		display: inline-block;
		svg {
			width: 2rem !important;
			height: 2rem !important;
			fill: ${(props) => props.theme.color[`grey500`]};
		}

		&.expand-icon {
			transform: rotate(45deg);
		}
	}

	.user-details-container {
		width: 100%;
		font: var(--primary-font);
	}

	.table-header-col-0,
	.table-header-col-1 {
		display: flex;
		align-items: center;
	}

	.table-row {
		.row-cell-0 {
			span {
				margin-right: 2rem;
			}
		}
	}
	.table-header-item > div {
		display: flex;
		max-width: 85%;
		.sort-label {
			max-width: 100%;
			margin-right: 0.5rem;
		}
	}

	.table-header-col-4,
	.table-header-col-2 {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.row-cell-0,
	.row-cell-1,
	.row-cell-2,
	.row-cell-3,
	.row-cell-4 {
		line-height: normal;
	}

	.ellipsis {
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
